import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Zap, Check, Loader2, TrendingUp } from "lucide-react";
import { toast } from "sonner";

export default function BoostListing() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [packages, setPackages] = useState([]);
  const [listing, setListing] = useState(null);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/boost/packages").then((r) => setPackages(r.data));
    api.get(`/listings/${id}`).then((r) => setListing(r.data)).catch(() => navigate("/dashboard"));
  }, [id, navigate]);

  const checkout = async () => {
    if (!selected) { toast.error("Pick a package"); return; }
    setLoading(true);
    try {
      const r = await api.post("/payments/checkout", { lookup_key: selected, listing_id: id, origin_url: window.location.origin });
      window.location.href = r.data.checkout_url;
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not start checkout");
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
      <div className="text-center mb-8">
        <div className="w-14 h-14 bg-blaze rounded-sm flex items-center justify-center mx-auto mb-4"><TrendingUp className="w-7 h-7 text-white" /></div>
        <h1 className="font-heading font-900 text-3xl uppercase tracking-tight">Boost Your Listing</h1>
        <p className="text-sm text-muted-foreground mt-2">{listing ? `Get "${listing.title}" in front of more buyers.` : "Get more eyes on your listing."}</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {packages.map((p) => (
          <button
            key={p.lookup_key}
            data-testid={`boost-pkg-${p.lookup_key}`}
            onClick={() => setSelected(p.lookup_key)}
            className={`text-left p-6 rounded-sm border transition-colors relative ${selected === p.lookup_key ? "border-blaze bg-[#141414]" : "border-border bg-[#141414] hover:border-blaze/50"}`}
          >
            {selected === p.lookup_key && <div className="absolute top-4 right-4 w-6 h-6 bg-blaze rounded-full flex items-center justify-center"><Check className="w-4 h-4 text-white" /></div>}
            <Zap className="w-6 h-6 text-blaze" />
            <div className="font-heading font-900 text-xl uppercase tracking-tight mt-3">{p.name}</div>
            <div className="font-heading font-900 text-4xl text-white mt-2 spec-block">${p.price}</div>
            <p className="text-sm text-muted-foreground mt-2">{p.desc}</p>
            <div className="text-xs text-blaze mt-3 spec-block uppercase tracking-wider">{p.days} days priority</div>
          </button>
        ))}
      </div>

      <div className="mt-6 flex gap-3">
        <Button onClick={() => navigate(-1)} variant="outline" className="border-border bg-transparent rounded-sm">Cancel</Button>
        <Button data-testid="boost-checkout-btn" onClick={checkout} disabled={loading || !selected} className="flex-1 bg-blaze hover:bg-blaze-hover text-white rounded-sm font-bold h-11 gap-2">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Zap className="w-4 h-4" />}
          Continue to Payment
        </Button>
      </div>
      <p className="text-center text-xs text-muted-foreground mt-4">Secure checkout via Stripe. Test card: 4242 4242 4242 4242</p>
    </div>
  );
}
